<script>
    import { getContext } from "svelte";
    import {
        Alert,
        Card,
        CardBody,
        Container,
        Row,
        Col,
        FormGroup,
        Label,
        TabContent,
        TabPane,
        Input,
        Modal,
        ModalBody,
        ModalHeader
    } from 'sveltestrap';
    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";

    import { _ } from "svelte-i18n";

    import RegisterForm from "./Forms/RegisterForm.svelte";
    import LoginForm from "./Forms/LoginForm.svelte";

    let apiUrl = getContext("apiUrl");

    let open = false;
    let size = "lg";
    const toggle = () => (open = !open);
    let result;

    const { form, errors, handleChange, handleSubmit } = createForm({
        initialValues: {
            ForgotEmail: ""
        },
        validationSchema: yup.object().shape({
            ForgotEmail: yup
            .string($_("components.Forms.errorMessage.string"))
            .email($_("components.Forms.errorMessage.email"))
            .required($_("components.Forms.errorMessage.string")),
        }),
        onSubmit: async () => {
            var Form = new FormData(document.getElementById("forgotPassword"))
            const res = await fetch(apiUrl + 'forgotPassword.php', {
                method: 'POST',
                body: Form
            })
            
            const json = await res.json()
            result = json
        },
    });
</script>

<Container>
    <Row>
        <Col lg="6" md="6" sm="12" xs="12">
            <table style="height: 100%;">
                <tbody>
                <tr>
                    <td class="align-middle">
                        <Card class="bg-dark border-dark shadow-lg card-body mb-3 mb-sm-3 mb-md-0 mb-lg-0 mb-xl-0 mb-xxl-0">
                            <h1 class="text-center fw-bolder">{$_("components.Register.slogan")} 👄</h1>
                        </Card>
                    </td>
                </tr>
                </tbody>
            </table>
        </Col>
        <Col lg="6" md="6" sm="12" xs="12">
            <Card class="card-body bg-dark border-dark shadow-lg">
                    <TabContent pills>
                        <TabPane tabId="register" tab="Inscription" class="mt-4">
                            <RegisterForm />
                        </TabPane>
                        <TabPane tabId="login" tab="Connexion" active class="mt-4">
                            <LoginForm {toggle}/>
                        </TabPane>
                    </TabContent>
            </Card>
        </Col>
    </Row>
</Container>

<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>{$_("components.Register.forgotPasswordModal.Title")}</ModalHeader>
    <ModalBody>
        {#if result}
            {#if result.success}
                <Alert color="success" dismissible>{result.success}</Alert>
            {/if}
        {/if}
        <form on:submit|preventDefault={handleSubmit} id="forgotPassword">
            <FormGroup>
                <p>
                    {$_("components.Register.forgotPasswordModal.Body")}
                </p>
                <Label for="ForgotEmail">{$_("components.Register.forgotPasswordModal.form.email")} :</Label>
                {#if $errors.ForgotEmail}
                    <Input 
                        type="email"
                        name="ForgotEmail"
                        id="ForgotEmail"
                        autocomplete="email"
                        bind:value={$form.ForgotEmail}
                        on:change={handleChange}
                        on:blur={handleChange}
                        invalid
                        feedback={$errors.ForgotEmail}
                        required
                    />
                {:else}
                    <Input 
                        type="email"
                        name="ForgotEmail"
                        id="ForgotEmail"
                        autocomplete="email"
                        bind:value={$form.ForgotEmail}
                        on:change={handleChange}
                        on:blur={handleChange} 
                        required
                    />
                {/if}
            </FormGroup>
            <div class="d-grid gap-2">
                <input type="submit" class="btn btn-primary" value="{$_("components.Register.forgotPasswordModal.form.send")}" />
            </div>
        </form>
    </ModalBody>
  </Modal>